// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"e97e2d41","349":"71d12dfe","425":"0c9920dd","437":"11c615f3","453":"1eb5cc81","534":"854cfcb9","538":"66b71d22","591":"0244626b"}[chunkId] + ".chunk.js";
};